import { AWSCloudAccount } from './AWS/AWSCloudAccount';
import { AzureCloudAccount } from './Azure/AzureCloudAccount';
import { GCPCloudAccount } from './GCP/GCPCloudAccount';
import { DownloadableCloudAccount } from './Downloadable/DownloadableCloudAccount';
import { CLOUD_TYPE } from '../../../../constants';

export const CLOUD_TYPE_COMPONENTS = {
    [CLOUD_TYPE.AWS]: AWSCloudAccount,
    [CLOUD_TYPE.AZURE]: AzureCloudAccount,
    [CLOUD_TYPE.AZURE_LOCAL]: AzureCloudAccount,
    [CLOUD_TYPE.GCP]: GCPCloudAccount,
    [CLOUD_TYPE.VSPHERE]: DownloadableCloudAccount,
    [CLOUD_TYPE.OPENSHIFT]: DownloadableCloudAccount,
    [CLOUD_TYPE.OPENSTACK]: DownloadableCloudAccount,
    [CLOUD_TYPE.NC2]: DownloadableCloudAccount,
    [CLOUD_TYPE.HPE_VME]: DownloadableCloudAccount,
    [CLOUD_TYPE.HYPERV]: DownloadableCloudAccount,
};

export const getCloudComponent = (cloudType) => {
    return CLOUD_TYPE_COMPONENTS[cloudType] || null;
};
